import React from 'react';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';

import {
    Row,
    Form,
    FormGroup,
    Col,
    Input,
    Label,
    Container,
    InputGroup,
    UncontrolledTooltip
} from 'reactstrap';
import { colorTheme } from '../../utils/constants';
import _ from 'lodash';

import {
    showLoading,
    fetchPropertyUnitUtilities,
    addUtilitiesBulk,
    sendInvoice,
    fetchCurrency,
    fetchPropertiesUnitsTenants
} from '../../redux/actions';
import dayjs from 'dayjs';
import IonCustomPropertySelect from '../../components/IonCustomPropertySelect';
import { IonAlert, IonButton, IonFooter, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonText } from '@ionic/react';
import { arrowBack, arrowForward, filter, hourglass, informationCircle, receipt } from 'ionicons/icons';
import CustomLabel from '../../components/CustomLabel';
import Wizard from '../../components/Wizard';
import { WizardStep } from '../../components/Wizard/WizardStep';
import { check_date_field, check_empty_field, check_if_number, check_if_positive_number } from '../Forms/validationChecks';
import { lexicographicalSortingOfUnits } from '../../utils/general';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        unitUtilities: state.unitUtilities,
        currency: state.currency
    };
}


const mapDispatchToProps = {
    showLoading,
    fetchPropertyUnitUtilities,
    addUtilitiesBulk,
    sendInvoice,
    fetchCurrency,
    fetchPropertiesUnitsTenants
};

const HOME_PAGE = "unitUtilities";
const PROPERTY_FORM_PAGE = "propertiesForm";
const SEQUENCE = ["Select Property and Utility", "Current Readings", "Create Invoices"]


class PropertyUtilities extends React.Component {
    constructor(props) {
        super(props);

        let utilsPropertyId = props.propertyId ? props.propertyId : "";
        let utilItem = props.utilityItem ? props.utilityItem : "";

        this.renderUnitUtilityFilters = this.renderUnitUtilityFilters.bind(this);
        this.renderUnitUtilitiesTable = this.renderUnitUtilitiesTable.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleSelectProperty = this.handleSelectProperty.bind(this);
        this.handleSelectUtilityItem = this.handleSelectUtilityItem.bind(this);
        this.handleSelectUnit = this.handleSelectUnit.bind(this);
        this.anyUtilityInvoiceToBeGenerated = this.anyUtilityInvoiceToBeGenerated.bind(this);

        this.state = {
            propertyId: "",
            properties: [],
            unitId: "",
            filters: {
                utilityItem: [
                    { id: 1, value: "water", isChecked: true },
                    { id: 2, value: "electricity", isChecked: true }
                ],
            },
            utilities: {},
            orderedUnits: [],
            utilityItem: "",
            utilItem,
            utilsPropertyId,
            utilsUnitId: "",
            errors: {},
            invoiceErrors: {
                invoiceDate: "",
                unitRate: ""
            },
            currentDateError: {},
            lesserCurrentReading: {},
            selectAll: false,
            alteredUnitUtilsObjects: [],
            invoiceIds: [],
            currentStep: SEQUENCE[0],
            createInvoicesOption: "Yes",
            unitRate: "",
            invoiceDate: new Date().toISOString().split('T')[0],
            showInvoiceAlert: false,
            successfullySubmitted: false

        }
    }

    async fetchInitialData(){
        if(_.isEmpty(this.props.currency)){
            this.props.showLoading(true);
            await this.props.fetchCurrency();
        }
        if(_.isEmpty(this.props.properties)){
            this.props.showLoading(true);
            await this.props.fetchPropertiesUnitsTenants();
        }
        this.props.showLoading(true);
        let payloadResult = await this.props.fetchPropertyUnitUtilities({ propertyIds: [this.state.utilsPropertyId], unitIds: [], utilityItem: this.state.utilItem });

        if (payloadResult && payloadResult.payload.unitUtilities) {

            let utilitiesPayload = payloadResult.payload.unitUtilities;
            let utilities = {};
            let propertyUnitIds = Object.keys(this.props.properties[this.state.utilsPropertyId].units);
            let propertyUnits = [];
            for (let unitId of propertyUnitIds){
                propertyUnits.push(this.props.units[unitId]);
            }
            propertyUnits.sort(this.sortUnits);
            for (let unit of propertyUnits) {
                let unitId = unit.unitId;
                utilities[unitId] = {
                    unit: unitId,
                    previousReading: utilitiesPayload[unitId] ? utilitiesPayload[unitId]["currentReading"] : "",
                    currentReading: null,
                    createInvoice: null,
                    date: utilitiesPayload[unitId] ? utilitiesPayload[unitId]["date"] : null,
                }
            }

            this.setState({
                utilities,
                orderedUnits: propertyUnits
            })
        }
    }

    async componentDidMount(){
        if(this.props.propertyId && this.props.utilityItem){
            await this.fetchInitialData();
        }
        if(Object.values(this.props.properties).length === 1){
            let errors = {}
            let currentDateError = {}
            let lesserCurrentReading = {}
            this.setState({
                utilsPropertyId: Object.values(this.props.properties)[0].propertyId,
                errors,
                currentDateError,
                lesserCurrentReading
            });
        }
        this.setState({properties: Object.values(this.props.properties)});
        // Mixpanel.track("Bulk upload Utilities: mounted");
    }


    async componentDidUpdate(prevProps, prevState) {

        if ((this.state.utilItem !== "" && this.state.utilsPropertyId !== "") &&
            (this.state.utilsPropertyId !== prevState.utilsPropertyId || this.state.utilItem !== prevState.utilItem || this.state.utilsUnitId !== prevState.utilsUnitId)
        ) {
            let errors = {}
            let currentDateError = {}
            let lesserCurrentReading = {}
            this.setState({
                errors,
                currentDateError,
                lesserCurrentReading
            })

            await this.fetchInitialData();
        }

    }

    formatUtilityDate(dateObject) {
        let date = "";
        let month = "";
        if (dayjs.isDayjs(dateObject)) {
            date = dateObject.date().toString();
            month = dateObject.format("MMM");
        } else {
            const jsDate = new Date(dateObject);
            date = jsDate.getDate().toString();
            month = dayjs(jsDate).format("MMM");
        }
        return date + ' ' + month;
    }

    sortUnits(a, b){
        return lexicographicalSortingOfUnits(a.unitName, b.unitName);
    }



    handleSelectProperty(event) {
        let value = event.target.value;
        const { utilItem } = this.state;

        if (event.target.name == "propertyId") {
            this.setState((prevState) => {
                let { utilsPropertyId, utilsUnitId, unitRate } = prevState;
                if (utilsPropertyId != value) {
                    utilsPropertyId = value;
                    utilsUnitId = "";
                }
                if (utilItem === "water"){
                    unitRate = this.props.properties[value].waterRate;
                } else if (utilItem === "electricity"){
                    unitRate = this.props.properties[value].electricityRate;
                }
                return {
                    utilsPropertyId, utilsUnitId, unitRate
                };
            });
        } else {
            this.setState((prevState) => {
                let { propertyId, unitId } = prevState;
                if (propertyId != value) {
                    propertyId = value;
                    unitId = "";
                }
                return {
                    propertyId, unitId
                };
            });
        }
        if(utilItem){this._nextStep();}
    }

    handleSelectUtilityItem(event) {
        let value = event.target.value;
        const { propertyId, utilsPropertyId } = this.state;

        this.setState((prevState) => {
            let { utilItem, unitRate } = prevState;
            if (utilItem != value) {
                utilItem = value;
            }
            if(propertyId || utilsPropertyId){
                if (value === "water"){
                    unitRate = this.props.properties[utilsPropertyId].waterRate || "";
                } else if (value === "electricity"){
                    unitRate = this.props.properties[utilsPropertyId].electricityRate || "";
                }
            }
            return {
                utilItem, unitRate
            };
        });
        if(propertyId || utilsPropertyId){this._nextStep();}
        // Mixpanel.track("Bulk upload utilities: item filter");
    }

    _prevStep = () => {
        const index = SEQUENCE.indexOf(this.state.currentStep);
        this.setState({
            currentStep: SEQUENCE[index - 1]
        });
    }

    _nextStep = () => {
        const index = SEQUENCE.indexOf(this.state.currentStep);
        this.setState({
            currentStep: SEQUENCE[index + 1]
        });
    }

    _changeStep = (stepId) => {
        this.setState({
            currentStep: stepId
        });
    }

    handleSelectUnit(event) {
        event.preventDefault();
        let value = event.target.value;
        let name = event.target.name;
        if (name == "unitId") {
            this.setState((prevState) => {
                let { utilsUnitId } = prevState;
                if (utilsUnitId != value) {
                    utilsUnitId = value;
                }
                return {
                    utilsUnitId
                }
            });

        } else {
            this.setState((prevState) => {
                let { unitId } = prevState;
                if (unitId != value) {
                    unitId = value;
                }
                return {
                    unitId
                }
            });
        }
        // Mixpanel.track("Bulk upload utilities: unit filter");
    }


    handleCheckChieldElement = async (event) => {
        event.preventDefault();

        const { value, checked } = event.target;
        await this.setState((prevState) => {
            let utilityItem = prevState.filters.utilityItem.map(i => {
                if (i.value === value) {
                    i.isChecked = checked
                }
                return { ...i };
            });
            return {
                filters: {
                    ...prevState.filters,
                    utilityItem
                }
            };
        });
    }

    onClickViewAllUtilities(event) {
        // TODO
        event.preventDefault();
        let previousPage = this.props.from;
        this.props.changeTab(previousPage);
    }

    onClickUpdateUtilityRate(event) {
        event.preventDefault();
        this.props.changeTab(PROPERTY_FORM_PAGE, this.state.utilsPropertyId, this.state.utilItem);
        Mixpanel.track("Bulk upload utilities: update utility rate");
    }

    anyUtilityInvoiceToBeGenerated(utilities){
        let anyInvoiceToBeGenerated = false;
        for (let util of Object.values(utilities)){
            if (util.createInvoice === true){
                anyInvoiceToBeGenerated = true;
            }
        }
        Mixpanel.track("Bulk upload utilities: any Utility Invoice to be generated");
        return anyInvoiceToBeGenerated;
    }

    async createUtilities(utilities, alteredUnitUtilsObjects, createInvoices, invoiceDate, unitRate){
        alteredUnitUtilsObjects = alteredUnitUtilsObjects.map(util => ({
                ...util,
                create_invoice: createInvoices
        }));
        let jsonString = JSON.stringify(alteredUnitUtilsObjects);
        let newJsonStr = jsonString.replace(/"/g, "'");  // replacing doublequotes with singlequotes for graphQL to accept
        this.props.showLoading(true);
        let action = await this.props.addUtilitiesBulk({
            utilityItem: this.state.utilItem,
            recordsJsonString: newJsonStr,
            invoiceDate: this.state.createInvoicesOption === "Yes" ? invoiceDate: "",
            utilityRate: this.state.createInvoicesOption === "Yes" ? unitRate : 0
        });

        let newUtilities = {}

        if (action && action.payload && action.payload.unitUtilities){
            newUtilities = action.payload.unitUtilities;
            let invoiceIds = []
            for (let util of Object.values(newUtilities)) {
                utilities[util.unit] = {
                    unit: util.unit,
                    previousReading: util.currentReading ? util.currentReading : "",
                    currentReading: null,
                    createInvoice: null,
                    date: util.date ? util.date : null,
                }

                if(util.invoiceId){
                    invoiceIds.push(util.invoiceId)
                }
            }

            if (createInvoices === true && invoiceDate == new Date().toISOString().split('T')[0] && invoiceIds.length > 0){
                this.handleShowInvoiceAlert();
            }

            let errors = {}
            let currentDateError = {}
            let lesserCurrentReading = {}

            this.setState({
                utilities,
                errors,
                currentDateError,
                lesserCurrentReading,
                invoiceIds,
                successfullySubmitted: true
            })

        }
    }

    handleChange(event) {
        let target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;

        let utilities = { ...this.state.utilities };
        let errors = {...this.state.errors};
        let lesserCurrentReading = {...this.state.lesserCurrentReading};
        let currentDateError = {...this.state.currentDateError};
        let unit = (name.split('_'))[0];


        if (target.type === 'checkbox') {
            utilities[unit]["createInvoice"] = val
        } else {
            utilities[unit]["currentReading"] = val != "" ? val : null
            // will avoid error where one enters value and clears it then validation still says it's not a number
            let todaysDate = dayjs();
            delete lesserCurrentReading[name];
            delete currentDateError[name];
            delete errors[name];
            let unitDateDayjs = null;
            if (dayjs.isDayjs(utilities[unit]["date"])) {
                unitDateDayjs = utilities[unit]["date"];
            } else {
                unitDateDayjs = dayjs(utilities[unit]["date"]);
            }

            if (isNaN(val)) {
                errors[name] = val;
            } else if (utilities[unit]["date"] && val !== "" && unitDateDayjs.format("MM/DD/YYYY") === todaysDate.format("MM/DD/YYYY")) {
                const todayDayjs = dayjs();
                if (unitDateDayjs.isSame(todayDayjs, "day")) {
                    currentDateError[name] = true;
                }
            } else if(parseFloat(val) < utilities[unit]["previousReading"]){
                lesserCurrentReading[name] = true;
            }
        }

        this.setState({ utilities: { ...utilities }, errors, lesserCurrentReading, currentDateError });

    }

    handleSelectAll(event){
        let utilities = {};

        if (this.state.utilities){
            utilities = {...this.state.utilities};
            for (let unit of Object.values(utilities)){
                unit["createInvoice"] = event.target.checked
            }

        }
        this.setState({
            selectAll: !this.state.selectAll,
            utilities: {...utilities}
        });

    }

    async handleSubmit() {
        const { invoiceDate, unitRate, invoiceIds } = this.state;

        let utilities = {...this.state.utilities};
        let alteredUnitUtilsObjects = [];
        let nonNumbers = {};
        for (let util of Object.values(utilities)) {
            if (util["currentReading"] != null) {
                if (isNaN(util["currentReading"])) {
                    nonNumbers[`${util["unit"]}_currentReading`] = util["currentReading"];
                } else {
                    alteredUnitUtilsObjects.push({
                        unit_id: util['unit'],
                        reading: util['currentReading'].includes('.') ? parseFloat(util["currentReading"]) : parseInt(util["currentReading"]),
                        create_invoice: false
                    })
                }
            }

        }

        let errors = {...nonNumbers};

        this.setState({ errors });

        let fields = ["unitRate", "invoiceDate"];
        let results = [];
        for(let field of fields){
            let isValid = this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter( (x) => !x);


        if (Object.keys(errors).length === 0 && invalid_fields.length === 0){
            let createInvoices = this.state.createInvoicesOption === "Yes" ? true : false;
            await this.createUtilities(utilities, alteredUnitUtilsObjects, createInvoices, invoiceDate, unitRate);
        }
    }


    validateInput = (name, value) => {
        let val = String(value);
        let isValid = true;
        let invoiceErrors = this.state.invoiceErrors;
        let checks = [];
        switch (name) {
            case "invoiceDate":
                checks = [check_date_field];
                break;
            case "unitRate":
                checks = [check_if_number, check_empty_field, check_if_positive_number];
                break;
            default:
                break;
        }
        for (let index in checks) {
            let previousError = invoiceErrors[name];
            invoiceErrors[name] = checks[index](val);
            if (invoiceErrors[name].length > 0) {
                if (previousError.length == 0) {
                    this.setState((prevState) => ({ numErrors: prevState.numErrors + 1 }));
                }
                isValid = false;
                break;
            } else if (previousError.length > 0) {
                this.setState((prevState) => ({ numErrors: prevState.numErrors - 1 }));
            }
        }
        return isValid;
    }

    handleCreateInvoiceOptionChange = (event) => {
        this.setState({ createInvoicesOption: event.target.value });
    }

    handleChangeUnitRate(event){
        this.validateInput("unitRate", event.target.value);
        this.setState({ unitRate: event.target.value });
    }

     handleShowInvoiceAlert = () => {
        this.setState(prevState => ({
            showInvoiceAlert: !prevState.showInvoiceAlert
        }));
    }

    renderUnitUtilityFilters() {
        let rate = "";
        if (this.state.utilItem === "water"){
            rate = "waterRate";
        } else if(this.state.utilItem === "electricity"){
            rate = "electricityRate";
        }
        return (
                <div>
                    <FormGroup row className='mt-5'>
                        <Col md={6}>
                        <IonLabel for="propertyId">
                            Select Property
                        </IonLabel>
                        <IonSelect
                            type="select"
                            name="propertyId"
                            interface="popover"
                            id="propertyId"
                            fill="solid"
                            className="filter-properties"
                            onIonChange={this.handleSelectProperty.bind(this)}
                            value={this.state.utilsPropertyId}
                        >
                            <IonCustomPropertySelect propertiesArray={this.state.properties}/>
                        </IonSelect>
                        </Col>

                        <Col md={6}>
                        <IonLabel for="utilityItem">
                            Select Utility
                        </IonLabel>

                        <IonSelect
                            type="select"
                            name="utilityItem"
                            interface="popover"
                            id="utilItem"
                            fill="solid"
                            className="filter-utilites"
                            onIonChange={this.handleSelectUtilityItem.bind(this)}
                            value={this.state.utilItem}
                        >
                            <IonSelectOption key={""} value="">Select Utility Item</IonSelectOption>
                            {_.map(this.state.filters.utilityItem, (item, index) => (
                                <IonSelectOption key={item.value} value={item.value}>
                                    {item.value}
                                </IonSelectOption>
                            ))}
                        </IonSelect>
                        </Col>
                    </FormGroup>

                    {this.state.utilsPropertyId && this.state.utilItem && this.props.properties[this.state.utilsPropertyId][rate] == 0 && (this.anyUtilityInvoiceToBeGenerated(this.state.utilities)) && (
                        <p className="text-danger" >Error: Cannot create invoices for these utilities because the utility rate for {this.state.utilItem} is invalid ({this.props.currency.customerCurrency} {this.props.properties[this.state.utilsPropertyId][rate]}).
                         Please <a onClick={this.onClickUpdateUtilityRate.bind(this)} style={{cursor: 'pointer', color: 'blue', textDecorationLine: 'underline'}}>click here</a> to update the utility rate.</p>
                        )
                    }

                </div>

        );
    }

    renderUtility(unit, index){
        let utility = this.state.utilities[unit.unitId];
        return (
            <Container key={unit.unitName}>
                <Row className="my-1 py-1 border-bottom display-flex align-items-center">
                    <Col sm={3} xs={2} xl={1.5}>
                        <Label for={"unit"}>
                            {unit.unitName}
                        </Label>
                    </Col>
                    <Col className='px-0 mx-0' sm={4} xs={5} xl={3}>
                        <Label for={"previousReading"}>
                            {utility.previousReading && `${utility.previousReading} (
                                ${utility.date ? this.formatUtilityDate(utility.date) : "now"})`}
                        </Label>
                    </Col>
                    <Col sm={5} xs={5} xl={2}>
                        <Input
                            id={`${unit.unitId}_currentReading`}
                            name={`${unit.unitId}_currentReading`}
                            className="current-reading-input"
                            value={utility.currentReading ? utility.currentReading : ""}
                            onChange={this.handleChange}
                        />

                        {`${unit.unitId}_currentReading` in this.state.errors && (<h6 className="text-danger pt-1" >Error: Not a number</h6>)}
                        {`${unit.unitId}_currentReading` in this.state.lesserCurrentReading && (<h6 className="text-warning pt-1" >Warning: Current reading is less than previous reading</h6>)}
                        {`${unit.unitId}_currentReading` in this.state.currentDateError && (<h6 className="text-warning pt-1" >Warning: Record already exists of the same utility type on the same day</h6>)}
                    </Col>
                </Row>
            </Container>

        )
    }

    renderInvoiceTable(unit, index){
        let utility = this.state.utilities[unit.unitId];
        return (
            <Container key={unit.unitName}>
                <Row className="mb-1">
                    <Col sm={5} xs={5} xl={3}>
                        <Label for={"unit"}>
                            {unit.unitName}
                        </Label>
                    </Col>
                    <Col sm={6} xs={6} xl={4}>
                        <IonText>{utility.currentReading ? (utility.currentReading - utility.previousReading) * this.state.unitRate : "-"}</IonText>
                    </Col>
                </Row>
                <hr
                    style={{
                        color: 'light-grey',
                    }}
                />
            </Container>

        )
    }

    renderUnitUtilitiesTable() {
        const { utilities, orderedUnits, errors } = this.state;
        return (
        <React.Fragment>
            {Object.keys(utilities).length !== 0 ? <div className='mt-3 mx-0 px-0'>
            <Row className="align-items-end">
                <Col
                    className="justify-content-end align-items-end px-0"
                    sm={2} xs={2} xl={1.5}>
                    <b>Unit</b>
                </Col>
                <Col className="mx-o px-0" sm={5} xs={5} xl={3}>
                    <b>Previous Reading <br></br> (Date recorded)</b>
                </Col>
                <Col className="d-flex justify-content-center mx-md-4" sm={4} xs={5} xl={2}>
                    <b>Current Reading</b>
                </Col>
            </Row>
            <hr
                style={{
                    color: 'light-grey'
                }}
            />
            <br />
            </div> : <div className='h6 mt-5'>The current Property does not have units with utility readings.</div>}
            <Row>
                <Col className='px-0 mx-0' sm={12}>
                    <Form onSubmit={e => e.preventDefault()}>
                        <div style={{ overflowY: 'scroll', overflowX: 'hidden', height:'400px' }}>
                            {_.map(orderedUnits, this.renderUtility.bind(this))}
                        </div>
                    </Form>
                </Col>

            </Row>
        </React.Fragment>);
    }

    renderCreateInvoices() {
        const { utilItem, createInvoicesOption, unitRate, invoiceIds, showInvoiceAlert, invoiceErrors, invoiceDate, orderedUnits } = this.state;
        return (
            <div className='mt-3'>
                <FormGroup row>
                    <IonText>Do you wish to create Invoices?</IonText>
                    <IonText><small>If not click submit to confirm created utilities</small></IonText>
                    <div className='form-group mt-2'>
                        <div className="form-check form-check-inline mr-3">
                          <label className="form-check-label">
                            <input
                            className="form-check-input"
                            type="radio"
                            name="create-invoices"
                            id="create-invoice-yes"
                            value="Yes"
                            checked={createInvoicesOption === 'Yes'}
                            onChange={this.handleCreateInvoiceOptionChange.bind(this)}
                            />
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <label className="form-check-label">
                            <input
                            className="form-check-input"
                            type="radio"
                            name="create-invoices"
                            id="create-invoices-no"
                            value="No"
                            checked={createInvoicesOption === 'No'}
                            onChange={this.handleCreateInvoiceOptionChange.bind(this)}
                            />
                            No
                          </label>
                        </div>
                        </div>
                </FormGroup>

                {/* Input for unit rate */}
                {createInvoicesOption === "Yes" && <div className='mt-3'>
                <hr/>
                <FormGroup row className='mt-3'>
                    <IonText>
                        {utilItem} rate per unit in ({this.props.currency.customerCurrency})
                    </IonText>

                    <Col className='mt-2' style={{maxWidth: '450px'}} sm={12} md={8}>
                        <InputGroup>
                            <Input
                                id="unitRate"
                                name="unitRate"
                                placeholder='Unit Rate'
                                value={unitRate}
                                onChange={this.handleChangeUnitRate.bind(this)}
                            />
                        </InputGroup>
                        <IonText><small>We will multiply unit rate by units consumed to find amount to invoice.</small></IonText>
                        {invoiceErrors.unitRate && (
                            <div className="text-danger">{invoiceErrors.unitRate}</div>
                        )}
                    </Col>
                </FormGroup>

                {/* Invoice date field */}
                <hr/>
                <FormGroup row className='mt-3'>
                    <IonText>Invoice Date</IonText>
                    <Col className='mt-2' style={{maxWidth: '450px'}} sm={12} md={8}>
                    <IonInput
                            type="date"
                            fill="solid"
                            value={invoiceDate}
                            onIonChange={(e) => {
                                const invoiceDate = e.detail.value;
                                this.setState({ invoiceDate });
                                this.validateInput("invoiceDate", invoiceDate);
                            }}
                        />
                    {invoiceErrors.invoiceDate && (
                        <div className="text-danger">{invoiceErrors.invoiceDate}</div>
                    )}
                </Col>
                    <IonText className='mt-2'>
                        <small>This is the date you want to invoice the tenants for the utility...</small>
                    </IonText>
                </FormGroup>

                <hr/>
                <FormGroup row className='mt-3'>
                <Container>
                <Row className="align-items-end">
                    <Col className="justify-content-end align-items-end" sm={5} xs={5} xl={3}>
                        <b>Unit</b>
                    </Col>
                    <Col sm={6} xs={6} xl={4}>
                        <CustomLabel for="invoiceAmountTooltip">
                        <b>Invoice Amount ({this.props.currency.customerCurrency}) <IonIcon id='invoiceAmountTooltip' icon={informationCircle}></IonIcon></b>
                        <UncontrolledTooltip placement="right" target="invoiceAmountTooltip">Unit Rate * Utility Consumed</UncontrolledTooltip>
                        </CustomLabel>
                    </Col>
                </Row>
                <hr
                    style={{
                        color: 'light-grey'
                    }}
                />
                <br />
                </Container>
                <div style={{ overflowY: 'scroll', overflowX: 'hidden', height:'400px' }}>
                    {_.map(orderedUnits, this.renderInvoiceTable.bind(this))}
                </div>
                </FormGroup>

                {/* Alert to for create invoices */}
                <IonAlert
                    isOpen={showInvoiceAlert}
                    onDidDismiss={this.handleShowInvoiceAlert.bind(this)}
                    header={'Send Invoice?'}
                    message={'For the created invoices, Do you wish to send invoices to tenants?'}
                    buttons={[
                        {
                            text: 'Yes, Send Tenants Invoice',
                            handler: () => {
                                this.props.showLoading(true);
                                this.props.sendInvoice({invoiceIds});
                                this.props.showLoading(false);
                            }
                        },
                        {
                            text: 'No',
                            handler: () => {
                            }
                        }
                    ]}
                />
                 </div>}
            </div>
        );
    }

    render() {
        const { currentStep, alteredUnitUtilsObjects } = this.state;
        return (
            <div>
            <div>
                <Wizard
                    activeStep={currentStep}
                    onStepChanged={(stepIndex) => this._changeStep(stepIndex)}
                >
                    <WizardStep
                        id={SEQUENCE[0]}
                        icon={ <IonIcon icon={filter}></IonIcon>}
                        complete={(this.state.propertyId || this.state.utilsPropertyId) && this.state.utilItem}
                    >
                        Select Property and Utility
                    </WizardStep>

                    <WizardStep
                        id={SEQUENCE[1]}
                        icon={ <IonIcon icon={hourglass}></IonIcon>}
                        complete={alteredUnitUtilsObjects.length > 0 && Object.keys(this.state.errors).length === 0}
                        disabled={(!this.state.propertyId && !this.state.utilsPropertyId) || !this.state.utilItem || Object.keys(this.state.errors).length > 0}
                    >
                        Add the Readings
                    </WizardStep>

                    <WizardStep
                        id={SEQUENCE[2]}
                        icon={ <IonIcon icon={receipt}></IonIcon>}
                        complete={false}
                        disabled={(!this.state.propertyId && !this.state.utilsPropertyId) || !this.state.utilItem || Object.keys(this.state.errors).length > 0}
                    >
                        Create Utilities/Invoices
                    </WizardStep>
                </Wizard>
                {
                    (() => {
                        switch(currentStep) {
                            case SEQUENCE[0]:
                                return this.renderUnitUtilityFilters();
                            case SEQUENCE[1]:
                                return this.renderUnitUtilitiesTable();
                            case SEQUENCE[2]:
                                return this.renderCreateInvoices();
                        }
                    })()
                }
            </div>
            <IonFooter className='px-1 rounded' style={{ display: "flex", justifyContent: "space-between", alignitems: "center" }}>
            {
                currentStep !== SEQUENCE[0] && (
                    <IonButton
                        onClick={() => {this._prevStep()}}
                        className='mr-3 rounded'
                        disabled={Object.keys(this.state.errors).length > 0}
                    >
                        <IonIcon icon={arrowBack}></IonIcon>
                        Previous
                    </IonButton>
                )
            }
            {
                currentStep == SEQUENCE[SEQUENCE.length - 1] ?
                (
                    <IonButton
                        style={{backgroundColor: colorTheme["primary"]["700"]}}
                        onClick={() => this.handleSubmit() }
                        className="ml-auto rounded"
                        size="md"
                        disabled={ Object.keys(this.state.errors).length > 0 || this.state.successfullySubmitted }
                    >
                        Submit
                    </IonButton>
                ) :
                (
                    <IonButton
                        style={{ borderColor: colorTheme["primary"]["700"] }}
                        onClick={() => {this._nextStep()}}
                        className="ml-auto rounded"
                        size="md"
                        disabled={(!this.state.propertyId && !this.state.utilsPropertyId) || !this.state.utilItem || Object.keys(this.state.errors).length > 0}
                    >
                        Next
                        <IonIcon icon={arrowForward}></IonIcon>
                    </IonButton>
                )
            }
            </IonFooter>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyUtilities);